import API from '../infraestructure/api';
import ApiError from './apiError';

export async function getServiceSolicitudes(data = '') {
  try {
    const response = await API.get(`/solicitudes${data}`);
    if (response && response.data) {
      return response.data;
    }
    return {};
  } catch (error) {
    const message = (error && error.response && error.response.data && error.response.data.message) || '';
    throw ApiError({ code: 'api/solicitudes/', message: `Hubo un problema al intentar buscar solicitudes. ${message}` });
  }
}

export async function getServiceSolicitud(data) {
  try {
    const response = await API.get(`/solicitudes/${data.id}`);
    if (response && response.data) {
      return response.data;
    }
    return {};
  } catch (error) {
    const message = (error && error.response && error.response.data && error.response.data.message) || '';
    throw ApiError({ code: 'api/solicitudes/', message: `Hubo un problema al intentar buscar solicitud. ${message}` });
  }
}

export async function postServiceSolicitud(data) {
  try {
    const response = await API.post('/solicitudes', data);
    if (response && response.headers && response.headers.location) {
      return response.headers.location;
    }
    return '';
  } catch (error) {
    const message = (error && error.response && error.response.data && error.response.data.message) || '';
    throw ApiError({ code: 'api/solicitudes/', message: `Hubo un problema al intentar crear solicitud. ${message}` });
  }
}

export async function putServiceSolicitud(data) {
  try {
    const response = await API.put('/solicitudes', data);
    if (response && response.data) {
      return response.data;
    }
    return {};
  } catch (error) {
    const message = (error && error.response && error.response.data && error.response.data.message) || '';
    throw ApiError({ code: 'api/solicitudes/', message: `Hubo un problema al intentar editar solicitud. ${message}` });
  }
}
